"use client";

import { cn, Skeleton, Typography } from "@kyan/ui";

import { ChainLogo } from "#/components/ChainLogo/ChainLogo";
import { BungeeToken } from "#/services/bridge/bridge.types";
import { getChainName } from "#/utils/chain";
import { formatValue } from "#/utils/valueFormatters";

interface ChainTokenProps {
  token: BungeeToken;
  hideBalance?: boolean;
  className?: string;
  direction?: "left" | "right";
}

export const ChainToken: React.FC<ChainTokenProps> = ({
  token: { chainId, symbol, decimals, logoURI, balance, balanceInUsd },
  hideBalance = false,
  className,
  direction = "left",
}) => {
  return (
    <div
      className={cn(
        "flex items-center gap-3",
        {
          "pr-2": direction === "left",
          "pl-2": direction === "right",
        },
        className,
      )}
    >
      <div className="relative">
        <img
          src={logoURI}
          alt={symbol + chainId}
          className="size-6 min-h-6 min-w-6 rounded-full"
        />
        <ChainLogo
          chain={chainId}
          className={cn(
            "border-primary absolute bottom-0 size-4 translate-1 rounded-full border",
            {
              "right-0": direction === "left",
              "-left-2": direction === "right",
            },
          )}
        />
      </div>

      {!hideBalance && (
        <>
          <Typography
            variant="secondary"
            className="flex flex-1 items-center gap-2"
          >
            {symbol}
            {!balance ? (
              <Skeleton className="inline-block w-10" />
            ) : (
              <>
                {" "}
                {formatValue(BigInt(balance || "0"), {
                  decimals,
                  precision: 4,
                  trailingZeroDisplay: "stripIfInteger",
                })}
                {Boolean(balanceInUsd) && <> (${balanceInUsd})</>}
              </>
            )}
          </Typography>
          <Typography variant="secondary">{getChainName(chainId)}</Typography>
        </>
      )}
    </div>
  );
};
